import api from '../services/api';

/**
 * Görseli backend üzerinden imgbb'ye yükler; API anahtarı yalnızca sunucuda tutulur.
 */
export async function uploadImageToImgBB(file: File): Promise<string> {
  const res = await api.uploadImageImgbb(file);
  if (!res.success || !res.data?.url) {
    throw new Error(res.error || 'Görsel yüklenemedi');
  }
  return res.data.url as string;
}
